import * as Types from '../constants/Types';

export const dataVoucherAction = (filters) => ({ type: Types.VOUCHER_LIST_ACTION, filters });
export const dataVoucherSuccess = (vouchers) => ({ type: Types.VOUCHER_LIST_SUCCESS, vouchers });
export const checkVoucherAction = (filters) => ({ type: Types.VOUCHER_CHECK_ACTION, filters });
export const checkVoucherSuccess = (resultCheck) => ({ type: Types.VOUCHER_CHECK_SUCCESS, resultCheck });
export const usedVoucherAction = (filters) => ({ type: Types.VOUCHER_USED_ACTION, filters });
export const usedVoucherSuccess = (usedVoucher) => ({ type: Types.VOUCHER_USED_SUCCESS, usedVoucher });
export const exportVoucherAction = (filters) => ({ type: Types.VOUCHER_EXPORT_ACTION, filters });
export const exportVoucherSuccess = (exVoucher) => ({ type: Types.VOUCHER_EXPORT_SUCCESS, exVoucher });
export const importVoucherAction = (params) => ({ type: Types.VOUCHER_IMPORT_ACTION, params });
export const importVoucherSuccess = (importData) => ({ type: Types.VOUCHER_IMPORT_SUCCESS, importData });
export const importVoucherFaild = (importErrors) => ({ type: Types.VOUCHER_IMPORT_FAILD, importErrors });
export const voucherReset = () => ({ type: Types.VOUCHER_RESET });
export const createVoucherAction = (params) => ({ type: Types.VOUCHER_CREATE_ACTION, params });
export const getItemVoucherAction = (params) => ({ type: Types.VOUCHER_GET_ITEM_ACTION, params });
export const getItemVoucherSuccess = (itemVoucher) => ({ type: Types.VOUCHER_GET_ITEM_SUCCESS, itemVoucher });
export const getHistoryVoucherAction = (params) => ({ type: Types.VOUCHER_GET_HISTORY_ACTION, params });
export const getHistoryVoucherSuccess = (historyVoucher) => ({ type: Types.VOUCHER_GET_HISTORY_SUCCESS, historyVoucher });
export const updateVoucherAction = (params) => ({ type: Types.VOUCHER_UPDATE_ACTION, params });
export const checkVoucherFailAction = (params) => ({ type: Types.VOUCHER_CHECK_FAIL, params });

export const exportExcel = (params) => ({ type: Types.VOUCHER_EXPORT_EXCEL_ACTION, params });

